import { createSlice } from "@reduxjs/toolkit";
import { GET_HOURLY_RATE_REQUEST_ACTION, GET_LANGUAGE_ACTION, NEW_LANGUAGE_APPROVE, NEW_LANGUAGE_REJECT, POST_HOURLY_RATE_REQUEST_ACTION } from "./LanguageSlice.action";
const LanguageSlice = createSlice({
    name: "language",
    initialState: {
        loading: false,
        error: null,
        language: [],
        hourlyRateRequest: [],
    },
    extraReducers: (builder) => {
        builder
            .addCase(GET_LANGUAGE_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GET_LANGUAGE_ACTION.fulfilled, (state, action) => {
                state.loading = false;
                state.language = action.payload;
            })
            .addCase(GET_LANGUAGE_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(GET_HOURLY_RATE_REQUEST_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GET_HOURLY_RATE_REQUEST_ACTION.fulfilled, (state, action) => {
                state.loading = false;
                state.hourlyRateRequest = action.payload;
            })
            .addCase(GET_HOURLY_RATE_REQUEST_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(POST_HOURLY_RATE_REQUEST_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(POST_HOURLY_RATE_REQUEST_ACTION.fulfilled, (state, action) => {
                state.loading = false;
                state.hourlyRateRequest = action.payload;
            })
            .addCase(POST_HOURLY_RATE_REQUEST_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            
            // ========APPROVE_REJECT_USER_NEW_LANGUAGE_ACTION========

            .addCase(NEW_LANGUAGE_APPROVE.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(NEW_LANGUAGE_APPROVE.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(NEW_LANGUAGE_APPROVE.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(NEW_LANGUAGE_REJECT.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(NEW_LANGUAGE_REJECT.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(NEW_LANGUAGE_REJECT.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    }
})
export default LanguageSlice;